import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import ActionButton from "../../../Button/ActionButton";
import LayoutWithList from "../../../LayoutModal/WithList";
import Delete from "../../Delete";
import Update from "../Update";
//hooks
import { useEffect, useState } from "react";
import apiRequest from "../../../../hooks/apiRequest";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//Icons
import { PencilSimple, Trash } from "@phosphor-icons/react";
//Interfaces
import { IAgreement, Inputs } from "Interfaces/IAgreement";

interface ICreate {
  isOpenModalMaterial: boolean;
  setModalClose: () => void;
  refreshFrames: () => void;
}

export default function CreateAgreements({
  isOpenModalMaterial,
  setModalClose,
  refreshFrames,
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const tableHead = ["#", "Nome", "Ações"];

  const [data, setData] = useState<IAgreement[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`agreement`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModalMaterial && data.length === 0) {
      fetchData();
    }
  }, [isOpenModalMaterial]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await apiRequest<IAgreement>("agreement", "POST", data);
      if (response.status === 201) {
        alert("Convênio criado com sucesso!");
        fetchData();
        refreshFrames();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar o fornecedor.");
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModalMaterial) {
    return (
      <LayoutWithList
        title="Registrar Convênio"
        subTitle="Cadastre um novo convênio em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Nome do convênio
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome do convênio"
                type="text"
                {...register("agreement", { required: true })}
              />
              {errors.agreement && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Tipo de Convênios Cadastrados</S.TitleList>

          <S.Table>
            <thead>
              <tr>
                {tableHead.map((val) => {
                  return <th>{val}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((val, index) => {
                return (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{val.agreement}</td>
                    <td>
                      <S.ContentButton>
                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "update")}
                        >
                          <PencilSimple size={20} />
                        </S.ButtonIconTable>

                        <S.ButtonIconTable
                          onClick={() => clickPopTable(val.id, "delete")}
                        >
                          <Trash size={20} color="red" />
                        </S.ButtonIconTable>
                      </S.ContentButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </S.Table>
        </S.Footer>

        <Update
          isOpenModalMaterial={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          updateList={fetchData}
        />

        <Delete
          updateList={fetchData}
          endpoint="material"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModal("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}
